export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9707.65fea220.jpg";